var styleDataHash = '8066f6a8';  
export const injectCss = (() => {
  var css = `.EucFO:after{content:"";height:calc(var(--mobile-toolbar-height) - var(--border-top) - var(--border-bottom));pointer-events:none;position:absolute;top:var(--border-top);width:calc(var(--mobile-toolbar-width, 0)*1px - var(--border-left) - var(--border-right))}[dir=ltr] .EucFO:after{background:linear-gradient(90deg,#fff 0,hsla(0,0%,100%,0) calc(var(--left-gradient-end, 0)*1%),hsla(0,0%,100%,0) calc(var(--right-gradient-start, 100)*1%),#fff 100%);left:var(--border-left)}[dir=rtl] .EucFO:after{background:linear-gradient(-90deg,#fff 0,hsla(0,0%,100%,0) calc(var(--left-gradient-end, 0)*1%),hsla(0,0%,100%,0) calc(var(--right-gradient-start, 100)*1%),#fff 100%);right:var(--border-left)}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "mobileToolbarOverlay": "EucFO"
};